document.addEventListener('DOMContentLoaded', function() {
    document.querySelector('.hero__button').addEventListener('click', function(e) {
      e.preventDefault(); // stop default action
      document.querySelector('.ecomsend__Popover__Widget__CustomContainer').click();
    });
});

// document.addEventListener('DOMContentLoaded', function() {
//     document.querySelector('.wt-page-nav-mega__link__text').addEventListener('click', function(e) {
//       e.preventDefault(); // stop default action
//       document.querySelector('.ecomsend__Popover__Widget__CustomContainer').click();
//     });
// });

document.addEventListener("DOMContentLoaded", function() {
  const offset = 120; // adjust this value as needed (in px)

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function() {
  const collapsibles = document.querySelectorAll('.wt-collapse__wrapper .wt-collapse');
  const expandBtn = document.querySelector('.expand-more-btn');
  const visibleCount = 3; // Show first 3

  if (!expandBtn || collapsibles.length <= visibleCount) {
    if (expandBtn) expandBtn.style.display = "none";
    return;
  }

  const btnText = expandBtn.querySelector('.btn-text');
  const btnIcon = expandBtn.querySelector('.btn-icon');

  // Initially hide sections after 3
  collapsibles.forEach((item, index) => {
    if (index >= visibleCount) {
      item.style.maxHeight = "0";
      item.style.overflow = "hidden";
      item.style.opacity = "0";
      item.style.transition = "all 0.4s ease";
    }
  });

  expandBtn.addEventListener("click", function(e) {
    e.preventDefault();
    const expanded = expandBtn.classList.toggle("expanded");

    collapsibles.forEach((item, index) => {
      if (index >= visibleCount) {
        if (expanded) {
          item.style.display = "block";
          setTimeout(() => {
            item.style.maxHeight = item.scrollHeight + "px";
            item.style.opacity = "1";
          }, 10);
        } else {
          item.style.maxHeight = "0";
          item.style.opacity = "0";
          setTimeout(() => {
            item.style.display = "none";
          }, 400);
        }
      }
    });

    btnText.textContent = expanded ? "Show Less" : "Expand More";
    // btnIcon.textContent = expanded ? "▴" : "▾";
  });
});